const state = {
    queue: [],
}

const getters = {
    getLifeByColor(color) {
        switch (color) {
            case 'red':
                return 30
            default:
                return 10
        }
    }
}

const mutations = {
    push: (state, item) => {
        let flash = JSON.parse(JSON.stringify(item))
        flash.color = flash.color || 'green'
        switch (flash.color) {
            case 'red':
                flash.life = 30
                break
            default:
                flash.life = 10
                break
        }
        flash.life = getters.getLifeByColor(flash.color)
        for (let i = state.queue.length - 1; i >= 0; i--) {
            if (flash.color === state.queue[i].color && flash.text === state.queue[i].text) {
                state.queue[i].life = 30
                return
            }
        }
        state.queue.push(flash)
    },
    process: (state, tick) => {
        if (!tick) {
            tick = 1
        }
        for (let i = state.queue.length - 1; i >= 0; i--) {
            state.queue[i].life -= tick
            if (state.queue[i].life <= 0) {
                state.queue.splice(i, 1)
            }
        }
    },
}

const actions = {
    async push (context, { color, text, }) {
        context.commit('push', { color: color, text: text, })
    },
    async process (context, tick = 1) {
        context.commit('process', tick)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


